import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DeploymentAdminModel, ModelService } from 'digiteq-ai-portal-client-lib';
import { MessageService } from 'primeng/api';
import { ErrorService } from '../../services/error.service';
import { finalize } from 'rxjs';
import { Column } from '../../models/column';
import { CrudHandlerComponent } from '../../components/crud-table/crud-handler/crud-handler.component';
import { ShowItemDialogModel } from '../../components/crud-table/crud-table.component';


@Component({
  selector: 'app-models-admin',
  templateUrl: './models-admin.component.html',
})
export class ModelsAdminComponent extends CrudHandlerComponent<DeploymentAdminModel> implements OnInit, AfterViewInit {
  @ViewChild('booleanTemplate') booleanTemplate: TemplateRef<HTMLTemplateElement>;
  @ViewChild('roleTemplate') roleTemplate: TemplateRef<HTMLTemplateElement>;

    columns: Column[] = []
    item?: DeploymentAdminModel;
    clonedItem: DeploymentAdminModel;
    search = '';

    constructor(
      messageService: MessageService,
      errorService: ErrorService,
      private readonly modelService: ModelService,
    ) {
      super (messageService, errorService);
      this.itemTypeName = 'Model';
    }

    ngOnInit() {
      this.modelService.getModelsAdmin().pipe(
          finalize(() => this.loading = false)
        )
        .subscribe({
          next: (result) => {
            this.items = result;
          },
          error: err => {
            this.errorService.handleError(err,'Could not load models');
          }
        })
    }

    ngAfterViewInit() {
      this.columns = [
        {field: 'modelFriendlyName', title: 'Model friendly name'},
        {field: 'deploymentName', title: 'Deployment name'},
        {field: 'modelType', title: 'Model type'},
        {field: 'endpoint', title: 'Endpoint'},
        {field: 'prompt', title: 'Prompt'},
        {field: 'maxInputTokens', title: 'Max input tokens'},
        {field: 'maxResponseTokens', title: 'Max response tokens'},
        {field: 'rolesRestriction', title: 'Roles restriction', template: this.roleTemplate},
        {field: 'note', title: 'Note'},
        {field: 'default', title: 'Default model',  template: this.booleanTemplate},
        {field: 'isSummary', title: 'Summary model',  template: this.booleanTemplate},
        {field: 'embeddingModel', title: 'Embedding model',  template: this.booleanTemplate},
      ];
    }

    toggle(item: DeploymentAdminModel) {
      if (!item.id) {
        return;
      }
      super.handleToggle(this.modelService.updateModel(item.id, item), item, this.itemTypeName);
    }

    delete(item: DeploymentAdminModel) {
      if (!item.id) {
        return;
      }
      super.handleDelete(this.modelService.deleteModel(item.id), item.id, this.itemTypeName);
    }

    onModelDialogCancel() {
      this.showItemDialog = false;
      this.clonedItem = null;
    }

    onShowItemDialog($event: ShowItemDialogModel) {
      this.showItemDialog = $event.show;
      this.clonedItem = $event.item;
    }

    getDialogHeader() {
      return this.clonedItem ? `Edit ${this.itemTypeName}` : `Add ${this.itemTypeName}`;
    }

    handleAddModel($event: DeploymentAdminModel) {
      if (!$event.restriction) {
        delete $event.rolesRestriction;
        delete $event.note;
      }

      this.handleAdd(this.modelService.createModel($event), this.itemTypeName);
    }

    handleEditModel($event: DeploymentAdminModel) {
      this.handleEdit(this.modelService.updateModel($event.id, $event), this.itemTypeName);
    }
 }
